import { Spinner } from 'Components/Spinner';
import React from 'react';
import { SpinnerStyled } from '../style';
import {
  ChartTitle,
  ChartTitleMoreInfo,
  ChartTitleText,
  GainersAndLosersBottemText,
  GainersAndLosersWrapper,
  RectangleGraphic,
  RectangleGraphicItem,
  RectangleGraphicText,
  RectangleGraphicWrapper,
} from './GainersAndLosers.style';

const GainersAndLosers = ({ data }) => {
  const generateGainersAndLosers = () => {
    let count = 2;
    if (!data?.length) return { start: [], end: [] };

    const plotData = data?.filter((i) => {
      if (count <= 10) {
        count++;
        return i;
      }
      return false;
    });
    const part = Math.floor(plotData.length / 2);
    return {
      start: [data[0], ...[...plotData].splice(0, part)].sort((a, b) =>
        a.change_percent > b.change_percent
          ? 1
          : a.change_percent < b.change_percent
          ? -1
          : 0
      ),
      end: [
        ...[...plotData].splice(part + 1, part * 2),
        data[data.length - 1],
      ].sort((a, b) =>
        a.change_percent < b.change_percent
          ? 1
          : a.change_percent > b.change_percent
          ? -1
          : 0
      ),
    };
  };

  return (
    <GainersAndLosersWrapper>
      {!data?.length && (
        <SpinnerStyled>
          <Spinner />
        </SpinnerStyled>
      )}
      <ChartTitle>
        <ChartTitleText>
          GAINERS & LOSERS
          <ChartTitleMoreInfo>&#105;</ChartTitleMoreInfo>
        </ChartTitleText>
      </ChartTitle>
      <RectangleGraphicWrapper parent>
        <RectangleGraphicWrapper>
          {generateGainersAndLosers().start.map((item, i) => (
            <RectangleGraphic key={`${item?.instrument}start${i}`}>
              <RectangleGraphicItem size={[40, 60, 80, 100, 140][i]}>
                <span>{item?.change_percent?.toFixed(2)}%</span>
              </RectangleGraphicItem>
              <RectangleGraphicText>
                {item?.instrument.slice(0, 6)}
              </RectangleGraphicText>
            </RectangleGraphic>
          ))}
        </RectangleGraphicWrapper>
        {/* section-2 */}
        <RectangleGraphicWrapper red>
          {generateGainersAndLosers().end.map((item, i) => (
            <RectangleGraphic key={`${item?.instrument}end${i}`}>
              <RectangleGraphicItem size={[40, 60, 80, 100, 140][i]}>
                <span>{item?.change_percent?.toFixed(2)}%</span>
              </RectangleGraphicItem>
              <RectangleGraphicText>
                {item?.instrument.slice(0, 6)}
              </RectangleGraphicText>
            </RectangleGraphic>
          ))}
        </RectangleGraphicWrapper>
      </RectangleGraphicWrapper>
      <GainersAndLosersBottemText>
        This chart represents gainers and losers per group of instruments and
        period of time chosen.
      </GainersAndLosersBottemText>
    </GainersAndLosersWrapper>
  );
};

export default GainersAndLosers;
